export interface PanVelocity {
  x: number;
  y: number;
}

export interface CanvasRect {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export const PAN_SPEED = 0.3;
const MIN_EDGE_DELTA = 10;

/**
 * Calculates the delta for pan movement based on canvas boundaries
 */
export function calculatePanDelta(
  currentPosition: number,
  boundStart: number,
  boundEnd: number,
  startCoord: number,
  delta: number,
): number {
  // If within bounds, no delta needed
  if (currentPosition > boundStart && currentPosition < boundEnd) {
    return 0;
  }

  // Calculate delta based on direction of movement
  const calculatedDelta = delta > 0 ? delta - (boundEnd - startCoord) : delta + (startCoord - boundStart);

  // If we're at the edge (delta is 0), provide a minimum value based on direction
  if (calculatedDelta === 0) {
    return currentPosition <= boundStart ? -MIN_EDGE_DELTA : MIN_EDGE_DELTA;
  }

  return calculatedDelta;
}

/**
 * Calculates pan velocity based on gesture input and canvas boundaries
 */
export function calculatePanVelocity(
  gestureEvent: HammerInput,
  canvasRect: CanvasRect,
  panStartCoords: { x: number; y: number },
): PanVelocity {
  const deltaX = calculatePanDelta(
    gestureEvent.center.x,
    canvasRect.left,
    canvasRect.right,
    panStartCoords.x,
    gestureEvent.deltaX,
  );

  const deltaY = calculatePanDelta(
    gestureEvent.center.y,
    canvasRect.top,
    canvasRect.bottom,
    panStartCoords.y,
    gestureEvent.deltaY,
  );

  return {
    x: -deltaX * PAN_SPEED,
    y: -deltaY * PAN_SPEED,
  };
}
